





























































import { Component, Prop, Vue } from 'vue-property-decorator';
import shapes from '@/common/utils/shapes';
import { isCompletedOrClosed } from '@/common/utils/routes';
import { Route, SearchResponse } from '@/api/types';
import RouteStopMarker from './RouteStopMarker.vue';
import AssetMarker from './AssetMarker.vue';
import { trackingMod } from '@/store/modules/tracking';
import { decodePath } from '@/common/utils/polyline';
import { InfoWindowReference } from '@/types/mapInfoWindow';
import { toLatLng, toLatLngs } from '@/common/utils/googleMaps';

@Component({
  components: {
    RouteStopMarker,
    AssetMarker
  }
})
export default class extends Vue {
  @Prop({ default: 'black' })
  colour!: string;

  @Prop({ required: true })
  route!: Route;

  @Prop({ required: true })
  isVisible!: boolean;

  @Prop({ required: true })
  item!: SearchResponse;

  private circleShapePath: string = shapes.CIRCLE;
  private markerShapePath: string = shapes.MAP_MARKER;

  get isCompletedRoute(): boolean {
    return isCompletedOrClosed(this.route.routeStatus);
  }

  get trackingDeviceIdentifier(): string {
    return this.route.trackable.trackingDeviceIdentifier;
  }

  get trackableAssetLocation(): google.maps.LatLngLiteral | null {
    const location = trackingMod.getTrackableAssetLocation(this.trackingDeviceIdentifier);

    if (location) {
      return toLatLng(location);
    }

    return null;
  }

  get trackableAssetHeading(): number | null {
    return trackingMod.getTrackableAssetHeading(this.trackingDeviceIdentifier);
  }

  get decodedPath() {
    return (encodedPolyLine: string): google.maps.LatLngLiteral[] => {
      return decodePath(encodedPolyLine);
    };
  }

  get travelledPath(): google.maps.LatLngLiteral[] {
    return toLatLngs(this.route.travelledPath);
  }

  get infoWindowReference(): InfoWindowReference {
    const info = {
      fleetNumber: this.route.trackable.fleetNumber,
      deliveryRunReference: this.route.deliveryRunReference
    };
    return info;
  }
}
